module.exports = __webpack_public_path__ + "static/media/StackTileWallShake.a20c246f.jpg";